// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewImage_bj6bI {
  max-width: 100%;
  object-fit: contain;
  aspect-ratio: 16 / 9;
}

.imageHolder_SnO9n {
  display: flex;
  background-color: black;
  min-height: 162px;
  position: relative;
  justify-content: center;
}

.loader_oJjdc {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: black;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/components/SimpleImageThumbnail.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,UAAU;AACZ","sourcesContent":[".previewImage {\n  max-width: 100%;\n  object-fit: contain;\n  aspect-ratio: 16 / 9;\n}\n\n.imageHolder {\n  display: flex;\n  background-color: black;\n  min-height: 162px;\n  position: relative;\n  justify-content: center;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  color: white;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: black;\n  z-index: 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewImage": `previewImage_bj6bI`,
	"imageHolder": `imageHolder_SnO9n`,
	"loader": `loader_oJjdc`
};
export default ___CSS_LOADER_EXPORT___;
